export interface IAuthentication {
    datePickerFormat?: string;
    expirationDate?: Date;
    isAuth: boolean;
    isConnected: boolean;
    isSuperAdmin: boolean;
    roles: string[];
    useRefreshTokens: boolean;
    userGuid: string;
    userId: string;
    userName: string;
}

export interface ILoginData {
    userName: string;
    password: string;
    session?: string;
}

export interface IAuthenticationHolderService {
    authentication: IAuthentication;
}

export class AuthenticationHolderService implements IAuthenticationHolderService {

    static serviceId = 'authenticationHolderService';
    authentication: IAuthentication;

    static $inject = [];
    constructor() {
        this.authentication = {
            datePickerFormat: null,
            isAuth: false,
            isConnected: false,
            isSuperAdmin: false,
            roles: [],
            useRefreshTokens: false,
            userGuid: '',
            userId: '',
            userName: ''
        };
    }
}